import { useNavigate } from 'react-router-dom';

import { ActionButton } from 'ui/actionButton/ActionButton';
import { AppRouteWithParams } from 'routing/AppRoute.enum';
import { usePermissions } from 'hooks/usePermissions/usePermissions';
import { Functionality } from 'api/userPermissions/userPermissions.enum';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';

import { GlcActionsProps } from './GlcActions.types';
import * as Styled from './GlcActions.styles';
import { ArchiveGlcContainer } from './archiveGlc/ArchiveGlcContainer';
import { UnarchiveGlcContainer } from './unarchiveGlc/UnarchiveGlcContainer';
import { DeleteGlcContainer } from './deleteGlc/DeleteGlcContainer';

export const GlcActions = ({ selectedGlc }: GlcActionsProps) => {
  const navigate = useNavigate();
  const { perms } = usePermissions();
  const { formatMessage } = useLocale();

  const isArchived = selectedGlc.archiwalny;
  const isArchiveAvailable = !isArchived && !selectedGlc.tkds?.length && !selectedGlc.uprGrupowe;
  const canBeDeleted = selectedGlc.canBeDeleted && !selectedGlc.tkds?.length;
  const canViewHistory = perms?.[Functionality.HISTORIA]?.view;

  return (
    <Styled.ButtonsWrapper>
      {canBeDeleted && <DeleteGlcContainer selectedGlc={selectedGlc} />}
      {!isArchived && (
        <ActionButton
          type="terminals"
          onClick={() => navigate(AppRouteWithParams.glcTerminals.get({ id: selectedGlc.id }))}
        />
      )}
      {isArchiveAvailable && <ArchiveGlcContainer selectedGlc={selectedGlc} />}
      {isArchived && <UnarchiveGlcContainer selectedGlc={selectedGlc} />}
      <ActionButton
        type="history"
        onClick={() => navigate(AppRouteWithParams.glcHistory.get({ id: selectedGlc.id }))}
        disabled={!canViewHistory}
        customTooltipText={!canViewHistory ? formatMessage({ id: AppMessages['common.noPermissions'] }) : undefined}
      />
    </Styled.ButtonsWrapper>
  );
};
